// Bag drawer: Add to bag (product page and tile quick-add) posts to /cart/add.js, swaps in the fresh drawer section,
// updates the header count and opens the drawer; then loads "Pairs with" for the item just added. Any failure falls
// back to the plain form post, which lands on /cart as before.
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const drawerSelector = '[data-bag-drawer]';

  const drawer = () => document.querySelector(drawerSelector);

  // One listener on the dialog itself: its contents are swapped on every add, so a listener on the Close button
  // would be lost with the old button. A click on the backdrop (the dialog box, outside the panel) also closes it.
  const bindDrawer = (dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-bag-close]')) dialog.close();
    });
  };

  const replaceDrawer = (html) => {
    const current = drawer();
    if (!current || !html) return current;
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(drawerSelector);
    if (!parsed) return current;
    current.replaceChildren(...parsed.childNodes);
    return current;
  };

  const updateCount = (count) => {
    const badge = document.querySelector('.pl-header__bag-count');
    if (!badge) return;
    badge.textContent = ` [${count}]`;
    badge.toggleAttribute('data-nonzero', count > 0);
  };

  const loadPairs = async (dialog, productId) => {
    const slot = dialog.querySelector('[data-bag-pairs]');
    if (!slot || !productId) return;
    try {
      const response = await fetch(`${root}recommendations/products?product_id=${productId}&limit=6&section_id=cart-pairs`);
      if (!response.ok) return;
      const html = await response.text();
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.pl-bagpairs');
      if (section) slot.replaceChildren(section);
    } catch {
      // Pairs are optional; the bag works without them.
    }
  };

  // A form already posting ignores further submits, so a double tap adds the item once.
  const inFlight = new WeakSet();

  const addToBag = async (form, submitter) => {
    if (inFlight.has(form)) return;
    inFlight.add(form);
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    let added;
    try {
      const response = await fetch(`${root}cart/add.js`, {method: 'POST', body, headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error(String(response.status));
      added = await response.json();
    } catch {
      // The add itself failed: the plain form post shows Shopify's own message on /cart.
      inFlight.delete(form);
      if (submitter) submitter.removeAttribute('aria-busy');
      form.submit();
      return;
    }
    // The item is in the bag now; anything that fails from here goes to /cart rather than posting it again.
    try {
      const dialog = replaceDrawer(added.sections?.['cart-drawer']);
      if (!dialog) throw new Error('no drawer');
      const cart = await (await fetch(`${root}cart.js`)).json();
      updateCount(cart.item_count);
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-bag-close]')?.focus();
      loadPairs(dialog, added.product_id);
    } catch {
      window.location.href = `${root}cart`;
    } finally {
      inFlight.delete(form);
      if (submitter) submitter.removeAttribute('aria-busy');
    }
  };

  const dialog = drawer();
  if (!dialog || typeof dialog.showModal !== 'function' || !window.fetch) return;
  bindDrawer(dialog);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.endsWith('/cart/add')) return;
    event.preventDefault();
    addToBag(form, event.submitter);
  });
})();

// Product tiles: on devices that hover, the second photo (back print, model shot or room view) loads on first hover
// and shows while the pointer is over the tile. Its address waits in data attributes so grids load one image a tile.
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  document.addEventListener('pointerover', (event) => {
    const tile = event.target instanceof Element ? event.target.closest('.pl-tile') : null;
    const alt = tile?.querySelector('img[data-hover-srcset]');
    if (!alt) return;
    alt.srcset = alt.dataset.hoverSrcset;
    alt.src = alt.dataset.hoverSrc;
    alt.removeAttribute('data-hover-srcset');
  });
})();
